export default __webpack_public_path__ + "static/media/code.16996981.svg";